/** @jsx jsx */
import { jsx } from '@emotion/core'
import SportsID1Img from '@assets/images/icon/emblem_icon/sport_id_1.png'
import SportsID2Img from '@assets/images/icon/emblem_icon/sport_id_2.png'
import SportsID3Img from '@assets/images/icon/emblem_icon/sport_id_3.png'
import SportsID4Img from '@assets/images/icon/emblem_icon/sport_id_4.png'
import SportsID5Img from '@assets/images/icon/sports_icon/sport_id_5.png'
import SportsID6Img from '@assets/images/icon/sports_icon/sport_id_6.png'
import SportsID7Img from '@assets/images/icon/sports_icon/sport_id_7.png'
import SportsID9Img from '@assets/images/icon/sports_icon/sport_id_9.png'
import SportsID10Img from '@assets/images/icon/sports_icon/sport_id_10.png'
import SportsID11Img from '@assets/images/icon/sports_icon/sport_id_11.png'
import SportsID12Img from '@assets/images/icon/sports_icon/sport_id_12.png'
import SportsID13Img from '@assets/images/icon/sports_icon/sport_id_13.png'
import SportsID14Img from '@assets/images/icon/sports_icon/sport_id_14.png'
import SportsID15Img from '@assets/images/icon/sports_icon/sport_id_15.png'
import SportsID16Img from '@assets/images/icon/sports_icon/sport_id_16.png'
import SportsID17Img from '@assets/images/icon/sports_icon/sport_id_17.png'
import SportsID18Img from '@assets/images/icon/sports_icon/sport_id_18.png'
import SportsID19Img from '@assets/images/icon/sports_icon/sport_id_19.png'
import SportsID20Img from '@assets/images/icon/sports_icon/sport_id_20.png'
import SportsID21Img from '@assets/images/icon/sports_icon/sport_id_21.png'
import SportsID22Img from '@assets/images/icon/sports_icon/sport_id_22.png'
import SportsID23Img from '@assets/images/icon/emblem_icon/sport_id_23.png'
import SportsID24Img from '@assets/images/icon/sports_icon/sport_id_24.png'
import SportsID25Img from '@assets/images/icon/sports_icon/sport_id_25.png'
import SportsID26Img from '@assets/images/icon/sports_icon/sport_id_26.png'
import SportsID28Img from '@assets/images/icon/sports_icon/sport_id_28.png'
import SportsID29Img from '@assets/images/icon/sports_icon/sport_id_29.png'
import SportsID31Img from '@assets/images/icon/sports_icon/sport_id_31.png'
import SportsID32Img from '@assets/images/icon/sports_icon/sport_id_32.png'
import SportsID34Img from '@assets/images/icon/sports_icon/sport_id_34.png'
import SportsID36Img from '@assets/images/icon/sports_icon/sport_id_36.png'
import SportsID37Img from '@assets/images/icon/sports_icon/sport_id_37.png'
import SportsID38Img from '@assets/images/icon/sports_icon/sport_id_38.png'
import SportsID39Img from '@assets/images/icon/sports_icon/sport_id_39.png'
import SportsID43Img from '@assets/images/icon/sports_icon/sport_id_43.png'
import SportsID44Img from '@assets/images/icon/sports_icon/sport_id_44.png'
import SportsID45Img from '@assets/images/icon/sports_icon/sport_id_45.png'
import SportsID46Img from '@assets/images/icon/sports_icon/sport_id_46.png'
import SportsID47Img from '@assets/images/icon/sports_icon/sport_id_47.png'
import SportsID48Img from '@assets/images/icon/sports_icon/sport_id_48.png'
import SportsID49Img from '@assets/images/icon/sports_icon/sport_id_49.png'
import SportsID50Img from '@assets/images/icon/sports_icon/sport_id_50.png'
import SportsID51Img from '@assets/images/icon/sports_icon/sport_id_51.png'
import SportsID55Img from '@assets/images/icon/sports_icon/sport_id_55.png'
import SportsID60Img from '@assets/images/icon/sports_icon/sport_id_60.png'
import SportsID61Img from '@assets/images/icon/sports_icon/sport_id_61.png'
import SportsID76Img from '@assets/images/icon/sports_icon/sport_id_76.png'
import SportsID81Img from '@assets/images/icon/sports_icon/sport_id_81.png'
import SportsID102Img from '@assets/images/icon/sports_icon/sport_id_102.png'
import SportsID103Img from '@assets/images/icon/sports_icon/sport_id_103.png'
import SportsID104Img from '@assets/images/icon/sports_icon/sport_id_104.png'
import SportsID105Img from '@assets/images/icon/sports_icon/sport_id_105.png'
import SportsID106Img from '@assets/images/icon/sports_icon/sport_id_106.png'
import SportsID109Img from '@assets/images/icon/sports_icon/sport_id_109.png'
import SportsID110Img from '@assets/images/icon/sports_icon/sport_id_110.png'
import SportsID111Img from '@assets/images/icon/sports_icon/sport_id_111.png'
import SportsID112Img from '@assets/images/icon/sports_icon/sport_id_112.png'
import SportsID113Img from '@assets/images/icon/sports_icon/sport_id_113.png'
import SportsID117Img from '@assets/images/icon/sports_icon/sport_id_117.png'
import SportsID118Img from '@assets/images/icon/sports_icon/sport_id_118.png'
import SportsID119Img from '@assets/images/icon/sports_icon/sport_id_119.png'
import SportsID121Img from '@assets/images/icon/sports_icon/sport_id_121.png'
import SportsID125Img from '@assets/images/icon/sports_icon/sport_id_125.png'
import SportsID127Img from '@assets/images/icon/sports_icon/sport_id_127.png'
import SportsID128Img from '@assets/images/icon/sports_icon/sport_id_128.png'
import SportsID135Img from '@assets/images/icon/sports_icon/sport_id_135.png'
import SportsID136Img from '@assets/images/icon/sports_icon/sport_id_136.png'
import SportsID137Img from '@assets/images/icon/sports_icon/sport_id_137.png'
import SportsID138Img from '@assets/images/icon/sports_icon/sport_id_138.png'
import SportsID140Img from '@assets/images/icon/sports_icon/sport_id_140.png'
import SportsID142Img from '@assets/images/icon/sports_icon/sport_id_142.png'
import SportsID152Img from '@assets/images/icon/sports_icon/sport_id_152.png'
import SportsID153Img from '@assets/images/icon/sports_icon/sport_id_153.png'
import SportsID155Img from '@assets/images/icon/sports_icon/sport_id_155.png'
import SportsID156Img from '@assets/images/icon/sports_icon/sport_id_156.png'
import SportsID157Img from '@assets/images/icon/sports_icon/sport_id_157.png'
import SportsID160Img from '@assets/images/icon/sports_icon/sport_id_160.png'
import SportsID162Img from '@assets/images/icon/sports_icon/sport_id_162.png'
import SportsID170Img from '@assets/images/icon/sports_icon/sport_id_170.png'
import { LogoIco } from '@shared/Icon/LogoIcon'

export const BASIC_TEAM_EMBLEM_MAP = {
  '1': SportsID1Img, // Soccer
  '2': SportsID2Img, // Basketball
  '3': SportsID3Img, // Baseball
  '4': SportsID4Img, // Ice Hockey
  '5': SportsID5Img, // Tennis
  '6': SportsID6Img, // Handball
  '7': SportsID7Img, // Floorball
  '9': SportsID9Img, // Golf
  '10': SportsID10Img, // Boxing
  '11': SportsID11Img, // Motor Sport
  '12': SportsID12Img, // Rugby
  '13': SportsID13Img, // Aussie Rules
  '14': SportsID14Img, // Winter Sports
  '15': SportsID15Img, // Bandy
  '16': SportsID16Img, // Football
  '17': SportsID17Img, // Cycling
  '18': SportsID18Img, // Specials
  '19': SportsID19Img, // Snooker
  '20': SportsID20Img, // Table Tennis
  '21': SportsID21Img, // Cricket
  '22': SportsID22Img, // Darts
  '23': SportsID23Img, // Volleyball
  '24': SportsID24Img, // Field Hockey
  '25': SportsID25Img, // Pool
  '26': SportsID26Img, // Waterpolo
  '28': SportsID28Img, // Curling
  '29': SportsID29Img, // Futsal
  '31': SportsID31Img, // Badminton
  '32': SportsID32Img, // Bowls
  '34': SportsID34Img, // Beach Volley
  '36': SportsID36Img, // Athletics
  '37': SportsID37Img, // Squash
  '38': SportsID38Img, // Rink Hockey
  '39': SportsID39Img, // Lacrosse
  '43': SportsID43Img, // Alpine Skiing
  '44': SportsID44Img, // Biathlon
  '45': SportsID45Img, // Bobsleigh
  '46': SportsID46Img, // Cross-Country
  '47': SportsID47Img, // Nordic Combined
  '48': SportsID48Img, // Ski Jumping
  '49': SportsID49Img, // Snowboard
  '50': SportsID50Img, // Speed Skating
  '51': SportsID51Img, // Luge
  '55': SportsID55Img, // Horse Racing
  '60': SportsID60Img, // Beach Soccer
  '61': SportsID61Img, // Pesapallo
  '76': SportsID76Img, // Equestrian
  '81': SportsID81Img, // Sailing
  '102': SportsID102Img, // Figure Skating
  '103': SportsID103Img, // Freestyle Skating
  '104': SportsID104Img, // Skeleton
  '105': SportsID105Img, // Short Track Speed Skating
  '106': SportsID106Img, // Soccer Mythical
  '109': SportsID109Img, // Esport Counter-Strike
  '110': SportsID110Img, // Esport League Of Legends
  '111': SportsID111Img, // Esport Dota
  '112': SportsID112Img, // Esport Starcraft
  '113': SportsID113Img, // Esport Hearthstone
  '117': SportsID117Img, // MMA
  '118': SportsID118Img, // Esport Call Of Duty
  '119': SportsID119Img, // Esport Smite
  '121': SportsID121Img, // Esport Overwatch
  '125': SportsID125Img, // Esport Rainbow Six
  '127': SportsID127Img, // Esport Street Fighter V
  '128': SportsID128Img, // Esport Rocket League
  '135': SportsID135Img, // Gaelic Football
  '136': SportsID136Img, // Gaelic Hurling
  '137': SportsID137Img, // Esport FIFA
  '138': SportsID138Img, // Kabaddi
  '140': SportsID140Img, // Esport Playerunknowns Battlegro
  '142': SportsID142Img, // Formula E
  '152': SportsID152Img, // Esport World Of Warcraft
  '153': SportsID153Img, // Esport NBA2K
  '155': SportsID155Img, // Basketball 3X3
  '156': SportsID156Img, // Esport Tekken
  '157': SportsID157Img, // Beach Handball
  '160': SportsID160Img, // Esport SSBM
  '162': SportsID162Img, // Esport Artifact
  '170': SportsID170Img, // Esport Fortnite
  '178': <LogoIco/>,
}
